import React from 'react';

export default function Component(props) {

const { question, answersList,surveyLanguageCode, handleRadio, clicked, surveyScreenData, isArabic,isMobile } = props;

return(
    <>
        <div className={isMobile?
        "grid grid-cols-1  py-6  lg:text-base text-sm font-normal  gap-3 mx-auto md:w-4/6 w-11/12":
        "grid grid-cols-1 ml-3 py-6  lg:text-base text-sm font-normal  gap-3 mr-auto md:w-4/6 w-11/12"}
        >
        {question && question.optionsList && question.optionsList.length>0?
          question.optionsList.map((option, optionindex) =>
          
          ((answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ?
          <span 
          onClick={() => handleRadio(optionindex, question, option)}
          style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
          className=" relative rounded-md border-2 p-1.5 flex items-center text-gray-500  cursor-pointer bg-black bg-opacity-10">
          <div className="flex items-center justify-start overflow-hidden"> 
            <span className="border bg-blue-500 border-white w-8 h-8 flex mr-3 rounded inline-flex items-center justify-center uppercase text-white">{String.fromCharCode(65+optionindex)}</span>
            <p className="">{(surveyLanguageCode!=='')?
          (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
              question.transl[surveyLanguageCode].optionsList[option.id]:option.name
          
          :option.name}</p> </div>
          <span className="material-icons absolute right-4">done</span></span>
          :
          <span 
          onClick={() => handleRadio(optionindex, question, option)}
          style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
          className=" relative rounded-md border p-1.5 flex items-center text-gray-500  bg-white bg-opacity-10 hover:bg-opacity-20">
          <div className="flex items-center justify-start overflow-hidden"> 
            <span className="border bg-blue-500 border-white w-8 h-8 flex mr-3 rounded inline-flex items-center justify-center uppercase text-white">{String.fromCharCode(65+optionindex)}</span>
            <p className="">{(surveyLanguageCode!=='')?
          (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
              question.transl[surveyLanguageCode].optionsList[option.id]:option.name
          
          :option.name}</p> </div>
          <span className="material-icons absolute right-4 hidden">done</span></span>)


    
          ):null}
        </div>
    </>
  );}